// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bf2791f4","453":"a4bb83fc","455":"875f6d7f"}[chunkId] + ".chunk.js";
};